import { watchEffect, type Ref } from 'vue'
import { useChatbotStore } from 'composables'

/**
 * Mirror the session identity (plus base URL and auth headers) into the chat
 * store for the whole lifetime of the widget. PkChatbot syncs these fields
 * only while mounted, but the store outlives it (the chat may be closed or
 * gated behind the session): the identity-switch reset in useChatbotStore
 * must start as soon as the new identity is known, not flash the previous
 * user's messages on the next open.
 *
 * `headers` is assigned before `userId` on purpose: the identity watcher in
 * the store probes the server as the new user, so the new credentials must
 * already be in place when it fires.
 */
// The return type is spelled out because inferring it reaches types of `ai`
// through `packages/components/node_modules`, a path the declaration emit cannot
// name (TS2883), which left this file without its `.d.ts`.
export function useChatbotStoreSync(options: {
    agentId: string
    baseUrl: string
    headers: Ref<Record<string, string> | undefined>
    userId: Ref<string | undefined>
}): ReturnType<typeof useChatbotStore> {
    const store = useChatbotStore(options.agentId)
    watchEffect(() => {
        store.baseUrl = options.baseUrl
        store.headers = options.headers.value
        store.userId = options.userId.value
    })
    return store
}
